import { Injectable, inject } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpHandlerFn } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApplicationStateService } from '../services/application-state.service';

let PROVIDER_IDENTIFIER = "clever";

export const cleverAuthorizationInterceptor = (request: HttpRequest<unknown>, next: HttpHandlerFn) => {
  let ssoInfo = inject(ApplicationStateService).getSSOInfo();

  if (request.withCredentials && ssoInfo?.provider.toLowerCase() === PROVIDER_IDENTIFIER)
  {
    let authHeader = `Bearer ${ssoInfo.bearerToken}`;
    request = request.clone({
      setHeaders: {
        Authorization: authHeader,
        'WF-SSO-Provider': PROVIDER_IDENTIFIER,
      }
    });
  }

  return next(request);
}
